let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5czKu")).then(() => parcelRequire('59UNr'));